export default __webpack_public_path__ + "static/media/disconnected.d8faab40.svg";